module.exports = __webpack_public_path__ + "static/media/KaTeX_Size4-Regular.3c14ed11.woff2";